import { API_ENDPOINTS } from '../constants/api-endpoints';
import { API } from './api-config';

const { ATTESTATION } = API_ENDPOINTS;
const { FIND_ONE, CURRENT, START, COMPLETE, STOP, GET_APPLICANTS, ABSENT } = ATTESTATION;

export const ApiAttestation = {
  fetchOne: (id: string | number) => {
    return API({
      path: FIND_ONE,
      method: 'GET',
      pathParams: { id },
    });
  },
  current: () => {
    return API({
      path: CURRENT,
      method: 'GET',
    });
  },
  start: (id: string | number, data: Record<string, any>) => {
    return API({
      path: START,
      method: 'POST',
      pathParams: { id },
      data,
    });
  },
  complete: (id: string | number, data: Record<string, any>) => {
    return API({
      path: COMPLETE,
      method: 'POST',
      pathParams: { id },
      data,
    });
  },
  stop: (id: string | number, reason: string) => {
    return API({
      path: STOP,
      method: 'POST',
      pathParams: { id },
      data: { reason },
    });
  },
  absent: (id: string | number, reason: string) => {
    return API({
      path: ABSENT,
      method: 'POST',
      pathParams: { id },
      data: { reason },
    });
  },
  getApplicants: () => {
    return API({
      path: GET_APPLICANTS,
      method: 'GET',
    });
  },
};
